module.exports = __webpack_public_path__ + "img/whole_box4_2.a6f31bec.jpg";